import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { StaticDocument } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ProfileActions from '@profile/profile.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromProfile from '@profile//profile.reducers';

import { SharedService } from '@shared/services/shared.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-guarantee',
  styleUrls: ['./guarantee.component.scss'],
  templateUrl: './guarantee.component.html',
  standalone: false
})
export class GuaranteeComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() guaranteeOpened = new EventEmitter<boolean>();
  @Input() isLoggedIn = true;
  @Input() location: string;
  appLocation: string;
  guaranteeLogo = ['tuv', 'baader', 'ent', 'inyova'];
  polyregDocument: StaticDocument;

  constructor(
    private trackingService: TrackingService,
    private store: Store,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.enableScroll(true);
    if (this.isLoggedIn) {
      this.store.dispatch(ProfileActions.fetchStaticDocs('3b'));
      this.store
        .select(fromAppRoot.selectCustomerAndCurrentAccount)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          if (!value || !value.customer || !value.customer.email || !value.currentAccountDetail?.onboarding_step) {
            return;
          }
          this.appLocation = value.customer.app_location;
        });
    } else {
      this.appLocation = this.location;
    }

    this.store
      .select(fromProfile.selectPolyregDocument)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((doc) => {
        this.polyregDocument = doc;
      });
  }

  close(): void {
    if (this.isLoggedIn) {
      this.trackingService.trackActivity('[Button] Close guarantee dialog');
    }
    this.enableScroll(false);
    this.guaranteeOpened.emit(false);
  }

  downloadPolyregDoc(): void {
    if (!this.polyregDocument) {
      return;
    }
    this.sharedService.downloadStaticDocument(this.polyregDocument.attributes.title, this.polyregDocument.id);
  }

  ngOnDestroy(): void {
    this.enableScroll(false);
  }

  private enableScroll(value: boolean) {
    if (value) {
      document.body.classList.add('js-modal-open');
    } else {
      document.body.classList.remove('js-modal-open');
    }
  }
}
